import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'

import { formatOptionsList } from '../../../../../../features/formatters'

import {
  choicesAllocationUnitsIsLoadingSelector,
  choicesAllocationUnitsSelector
} from '../../../../../../modules/selectors/choices'

import { ALLOCATION, ALLOCATION_UNIT, DELIVERED } from '../../fields'

import useStyles from '../../styles'
import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function RightAllocationAndDelivery({
  formik,
  sectionDescription = 'Please enter the number of items (e.g. boards, shirts, impressions, emails etc.) to be provided under this right. Please also enter the amount delivered to date (if any).',
  showUnitsField = true,
  showDeliveredAmountSection = true
}) {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const allocationUnits = useSelector(choicesAllocationUnitsSelector)
  const choicesAllocationUnitsIsLoading = useSelector(choicesAllocationUnitsIsLoadingSelector)

  const allocationUnitsList = formatOptionsList({
    list: allocationUnits,
    valueName: 'id',
    labelName: 'name'
  })

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Allocation and delivery')}</h3>
      <p>{t(sectionDescription)}</p>
      <section className={drawerFormClasses.subSection}>
        <FieldLabelWrapper label="Allocation" labelFor={ALLOCATION}>
          <div className={classes.allocationFieldsContainer}>
            <Field
              type="number"
              placeholder="Allocation amount"
              formik={formik}
              name={ALLOCATION}
              enableReinitialize
              decimalScale={0}
              autoComplete="off"
            />
            {showUnitsField && (
              <Field
                placeholder="Units"
                formik={formik}
                name={ALLOCATION_UNIT}
                options={allocationUnitsList}
                enableReinitialize
                autoComplete="off"
                isLoading={choicesAllocationUnitsIsLoading}
              />
            )}
          </div>
        </FieldLabelWrapper>
      </section>
      {showDeliveredAmountSection && (
        <section className={drawerFormClasses.subSection}>
          <FieldLabelWrapper label="Delivered" labelFor={DELIVERED}>
            <div className={classes.allocationFieldsContainer}>
              <Field
                type="number"
                placeholder="Delivered amount"
                formik={formik}
                name={DELIVERED}
                enableReinitialize
                decimalScale={0}
                autoComplete="off"
              />
            </div>
          </FieldLabelWrapper>
        </section>
      )}
    </section>
  )
}

export default RightAllocationAndDelivery
